import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal, Button } from "react-bootstrap";

const Checkout = ({ showModal, handleClose }) => {
  return (
    <>
      {/* Modal */}
      <Modal show={showModal} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Checkout</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid checkout-container">
            <div className="row">
              {/* Left Sidebar - Order Summary */}
              <div className="col-md-5 col-12 bg-danger text-white p-4">
                <div className="d-flex align-items-center mb-4">
                  <img
                    src="https://example.com/logo-url.png" 
                    alt="Logo"
                    className="logo me-2"
                    style={{ width: "50px" }}
                  />
                  <div>
                    <h4>Neelgagan</h4>
                    <p className="mb-0">Razorpay Trusted Business</p>
                  </div>
                </div>

                <div className="order-summary mt-3">
                  <h5>Order summary</h5>
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <img
                      src="https://example.com/item-image-url.png"
                      alt="Product"
                      className="product-image"
                      style={{ width: "50px" }}
                    />
                    <div>
                      <p className="mb-1">
                        Slip Pad No. 33, Ruled & Plain (14.0 cm x 22.0 cm)
                      </p>
                      <p className="mb-0">Qty: 1</p>
                    </div>
                    <p className="mb-0">₹36</p>
                  </div>

                  {/* Additional Information */}
                  <div className="mt-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <span>GST Number</span>
                      <button className="btn btn-outline-light btn-sm">
                        Add +
                      </button>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                      <span>Order Instructions</span>
                      <button className="btn btn-outline-light btn-sm">
                        Add +
                      </button>
                    </div>
                  </div>

                  <div className="mt-4">
                    <button className="btn btn-outline-light btn-block w-100">
                      Add a coupon code
                    </button>
                  </div>
                </div>

                {/* Secured by Razorpay */}
                <div className="mt-4">
                  <p className="text-center">
                    Secured by <strong>Razorpay</strong>
                  </p>
                </div>
              </div>

              {/* Right Section - Contact Details */}
              <div className="col-md-7 col-12 p-4">
                <h4>Contact details</h4>
                <p>Enter mobile & email to continue</p>

                {/* Mobile Number */}
                <div className="mb-3">
                  <label className="form-label">Mobile Number</label>
                  <div className="input-group">
                    <span className="input-group-text">+91</span>
                    <input
                      type="tel"
                      className="form-control"
                      placeholder="Mobile number"
                    />
                  </div>
                  <p className="text-danger mt-1">
                    Please enter your mobile number
                  </p>
                </div>

                {/* Email Address */}
                <div className="mb-3">
                  <label className="form-label">Email Address</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email address"
                  />
                </div>

                {/* Offers Checkbox */}
                <div className="form-check mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="offersCheckbox"
                  />
                  <label className="form-check-label" htmlFor="offersCheckbox">
                    Send me offers and order updates
                  </label>
                </div>

                {/* Continue Button */}
                <button className="btn btn-dark w-100">Continue</button>

                {/* Payment Methods */}
                <div className="mt-4 d-flex justify-content-between">
                  <img
                    src="https://example.com/rupay.png"
                    alt="Rupay"
                    style={{ width: "50px" }}
                  />
                  <img
                    src="https://example.com/visa.png"
                    alt="Visa"
                    style={{ width: "50px" }}
                  />
                  <img
                    src="https://example.com/upipay.png"
                    alt="UPI"
                    style={{ width: "50px" }}
                  />
                  {/* Add more payment icons as needed */}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Checkout;
